import { combineReducers } from 'redux';
import bank from 'src/redux/reducers/bankReducer';
import catalog from 'src/redux/reducers/catalogReducer';
import category from 'src/redux/reducers/categoryReducer';
import common from 'src/redux/reducers/commonReducer';
import config from 'src/redux/reducers/configReducer';
import deal from 'src/redux/reducers/dealReducer';
import deposit from 'src/redux/reducers/depositReducer';
import location from 'src/redux/reducers/locationReducer';
import notification from 'src/redux/reducers/notification';
import profile from 'src/redux/reducers/profileReducer';
import referral from 'src/redux/reducers/referralReducer';
import saleOrder from 'src/redux/reducers/saleOrderReducer';
import tracking from 'src/redux/reducers/trackingReducer';
import user from 'src/redux/reducers/userReducer';
import vnTracking from 'src/redux/reducers/vnTracking';
import website from 'src/redux/reducers/websiteReducer';

export default combineReducers({
  bank,
  catalog,
  category,
  common,
  config,
  deal,
  deposit,
  location,
  notification,
  profile,
  referral,
  saleOrder,
  tracking,
  user,
  vnTracking,
  website
});
